export const initFormPopup = () => {
    const toggleLinks = document.querySelectorAll('.toggle-contact a');
    console.log(toggleLinks);
    const popup = document.querySelector('.footer-contact');

    if (!toggleLinks.length || !popup) return;

    toggleLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            e.stopPropagation(); // Zapobiegamy propagacji do elementu nadrzędnego
            popup.classList.add('is-active');
            document.body.style.overflow = 'hidden';
        });
    });

    // Zamykanie po kliknięciu w tło
    popup.addEventListener('click', e => {
        if (e.target === popup) {
            popup.classList.remove('is-active');
            document.body.style.overflow = '';
        }
    });

    // Dodajemy obsługę klawisza ESC
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && popup.classList.contains('is-active')) {
            popup.classList.remove('is-active');
            document.body.style.overflow = '';
        }
    });
};

initFormPopup();
